import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminUsuariosPage } from "@/features/admin-usuarios/components/AdminUsuariosPage";
import { usuariosAdminQueryOptions } from "@/features/admin-usuarios/hooks/use-usuarios-admin";
import { areasAdminQueryOptions } from "@/features/admin-areas/hooks/use-areas-admin";
import { organizacionesAdminQueryOptions } from "@/features/admin-organizaciones/hooks/use-organizaciones-admin";
import { rolesAdminQueryOptions } from "@/features/admin-roles/hooks/use-roles-admin";

/**
 * Ruta `/admin/usuarios` · precarga 3 queries en paralelo (usuarios +
 * áreas + organizaciones).
 */
export const Route = createFileRoute("/_authed-tw/admin/usuarios")({
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      // Primera página del listado (params default del componente).
      queryClient.ensureQueryData(usuariosAdminQueryOptions({ page: 1, pageSize: 15 })),
      // Catálogos completos · el panel de edición asigna sobre TODO el catálogo.
      queryClient.ensureQueryData(areasAdminQueryOptions),
      queryClient.ensureQueryData(organizacionesAdminQueryOptions),
      // Roles asignables (sistema + personalizados) para los checkboxes del panel.
      queryClient.ensureQueryData(rolesAdminQueryOptions),
    ]),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminUsuarios]}>
      <AdminUsuariosPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
